import React from 'react'
import Skeleton from 'react-loading-skeleton'

function SingleRendezVousSkeleton() {
  return (
    <div className="rendezvous-single main-content">
          <div className="rendezvous-header">
            <h2>
              <Skeleton width={250} height={24} />
            </h2>
            <div className="rendezvous-status">
              <Skeleton circle width={40} height={40} />
              <Skeleton circle width={40} height={40} />
            </div>
          </div>

          <div className="service-info">
            <div className="infos-pratiques">
              <h4>
                <Skeleton width={200} height={20} />
              </h4>
              <div className="infos-time-price">
                <div className="infos-time">
                  <Skeleton width={120} height={16} />
                </div>
                <div className="infos-price">
                  <Skeleton width={100} height={16} />
                </div>
              </div>
              <div className="infos-location">
                <Skeleton width={250} height={16} />
              </div>
            </div>
          </div>

          <div className="professional-info">
            <h4>
              <Skeleton width={150} height={20} />
            </h4>
            <div className="professional-details">
              <Skeleton width={200} height={16} />
              <Skeleton width={180} height={16} style={{ marginTop: 8 }} />
              <Skeleton width={120} height={16} style={{ marginTop: 8 }} />
            </div>
          </div>

          <div className="action-links">
            <Skeleton width={200} height={40} style={{ borderRadius: "8px" }} />
            <Skeleton
              width={200}
              height={40}
              style={{ borderRadius: "8px", marginTop: "12px" }}
            />
          </div>
        </div>
  )
}

export default SingleRendezVousSkeleton